module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s03-2_s-8093f38ee95ca10feef5a55708b56625.png";